module.exports = __webpack_public_path__ + "static/media/group-leader.094e0279.svg";